import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import appConfig from 'appConfig';
import introspectionQueryResultData from 'graphQLSchema/fragmentTypes.json';
import { loadSession } from '../data/CurrentUser/sessionManager';
import dataIdFromObject from './cacheNormalization';

const createApolloClient = () => {
  const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData,
  });

  const cache = new InMemoryCache({ fragmentMatcher, dataIdFromObject });

  const httpLink = createHttpLink({
    uri: appConfig.getAuthorGraphqlEndpoint(),
  });

  const authLink = setContext(async(_, { headers }) => {
    const token = loadSession();
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    connectToDevTools: process.env.NODE_ENV === 'development',
    cache,
    resolvers: {},
  });
};

export { createApolloClient };
